module.exports = __webpack_public_path__ + "img/calendar.491d3307.svg";